// extracted by mini-css-extract-plugin
export default {"sectionWrapper":"Zp-z","outfitFeedbackSection":"_p-z"};